// frontend/modules/template/components/NotificationsSidebar.tsx
import React from 'react';
import { Menu } from 'antd';
import { 
  FileTextOutlined, 
  CodeOutlined, 
  TransactionOutlined
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

export const NotificationsSidebar: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;
    
    const handleMenuClick = ({ key }: { key: string }) => {
        navigate(key);
    };
    
    // Define the items for the sidebar menu
    const menuItems = [
        {
            key: '/notifications/templates',
            icon: <FileTextOutlined />,
            label: 'Templates',
        },
        {
            key: '/notifications/context-scripts',
            icon: <CodeOutlined />,
            label: 'Context Scripts',
        },
        {
            key: '/notifications/context-transformation',
            icon: <TransactionOutlined />,
            label: 'Transform & Process',
        },
    ];
    
    // Find the currently selected key based on the current path
    const selectedKey = menuItems.find(item => 
        currentPath.startsWith(item.key)
    )?.key || '/notifications/templates';
    
    return (
        <div className="border-r h-full">
            <Menu
                mode="inline"
                selectedKeys={[selectedKey]}
                items={menuItems}
                onClick={handleMenuClick}
                className="h-full"
                style={{ borderRight: 0 }}
            />
        </div>
    );
};
